// Persisted task-list filter selections. Both survive navigation on purpose, so a
// filter picked once keeps applying while the technician works through a list.
// Screens that show task counts of their own clear them: those counts are fetched
// unfiltered, so a sticky filter would make the number on a card disagree with the
// list it opens.
export const TASK_FILTER_KEYS_STORAGE_KEY = 'taskListFilterKeys';
export const TASK_DATE_FILTER_STORAGE_KEY = 'taskDateFilter';
// Deliberately absent from clearTaskListFilters below: a sort only reorders a
// list, it never changes what is in it, so it cannot make a card's count
// disagree with the list it opens. A chosen order sticks until changed.
export const TASK_SORT_FILTER_STORAGE_KEY = 'taskSortFilter';

export function clearTaskListFilters() {
    localStorage.removeItem(TASK_FILTER_KEYS_STORAGE_KEY);
    localStorage.removeItem(TASK_DATE_FILTER_STORAGE_KEY);
}
